import React, { Component } from "react";
import { Typography } from '@material-ui/core';
import { loginRoute } from '../services/routes';
import { Link } from "react-router-dom";

export default class Logout extends Component {
    render() {
        return (<div><Typography variant="h6">
            You are logged out.
        </Typography>
        <Link to={loginRoute}>Login again</Link>
        </div>);
    }
}